// Libraries
var React = require('react');

// Styles
require('./OptaWidget.scss');

class OptaWidget extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			widgetsAvailable: true
		}
	}

	componentDidMount = () => {

		if (!document.getElementById('optaStyles')) {
			const e = document.createElement('link');
			e.rel = 'stylesheet';
			e.href = 'https://secure.widget.cloud.opta.net/v3/css/v3.football.opta-widgets.css';
			e.id = 'optaStyles';
			document.head.appendChild(e);
		}

		if(window.location.hostname === "localhost") {
			this.setState({widgetsAvailable: false});
		} else {
			window.opta_settings = window.opta_settings || {
				subscription_id: this.props.subscriptionId,
				language: this.props.language,
				timezone: this.props.timezone
			};

			let element = this.optaProperties;

			this.props.properties.forEach(function(property) {
				if(property.key.length > 0) {
					element.setAttribute(property.key, property.value);
				}
			});

			let url = "https://secure.widget.cloud.opta.net/v3/v3.opta-widgets.js";
			if(!this.scriptExists(url)) {
				let scriptTag = document.createElement('script');            
				scriptTag.src = url;
				document.getElementsByTagName('body')[0].appendChild(scriptTag);
			}
		}
	}

	scriptExists = (url) => {
		let scripts = document.getElementsByTagName('script');
		for (let i = 0; i < scripts.length; i++) {
			if (scripts[i].src === url) return true;
		}
		return false;
	}

	render() {
		return (
			this.state.widgetsAvailable ? <opta-widget ref={(optaProperties) => { this.optaProperties = optaProperties; }} /> : <p>This domain isn't supported for Opta Widgets, see start.js to enable</p>
		)
	}
}

module.exports = OptaWidget;



// WEBPACK FOOTER //
// ./src/components/MDC/OptaWidget/OptaWidget.js